<div #box cdkDrag cdkDragBoundary=".boundary" (cdkDragMoved)="onDrag($event)" (mousewheel)="onMouseWheel($event); false" style="overflow: hidden; position: absolute; cursor: move;"
     (window:mouseup)="setStatus($event, 0)" (mousedown)="setStatus($event, 2)"
     [style.width.px]="width" [style.height.px]="height" data-cy="collage-draggable-container">
  <div style="position: relative;" data-cy="collage-draggable-wrapper">
    <div style="width: 100%; height: 100%;" (mousemove)="onMouseMove($event)" data-cy="collage-draggable-image-wrapper">
      <img #tdoImage crossorigin="anonymous"
           [src]="imageSource | secureImage | async"
           [style.transform-origin]="originX + 'px ' + originY + 'px'"
           style="height: 100%; width: 100%;"
           [style.transform]="'scale(' + scale + ',' + scale + ')'" data-cy="collage-draggable-image" />
    </div>
    <div class="resize-action-bottom-right" [style.border-color]="dragAreaColor" style="; user-select: none;" (mousedown)="setStatus($event, 1)" data-cy="collage-draggable-resize-handle"></div>
  </div>
</div>
